import React, { useState, useEffect } from "react";
import { PageHeader } from "components/ui";
import {
  Grid,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import StandardsSelector from "components/customizedStandardsComponent/GriStandardsSelector";
import UploadEvidenceComponent from "components/customizedStandardsComponent/UploadEvidenceComponent";
import DownloadReport from "components/customizedStandardsComponent/DownloadReport";
import DownloadPostReviewGapForm from "components/customizedStandardsComponent/DownloadPostReviewGapForm";
import UploadPostReviewGapForm from "components/customizedStandardsComponent/UploadPostReviewGapForm";
import DownloadPostReviewReports from "components/customizedStandardsComponent/DownloadPostReviewReports";
import {
  COMPANY_IDENTIFICATION_OPERATIONAL,
  ACTIVITY_SPECIFICATION_OPERATIONAL,
  REQUIREMENT_SELECTION_INT_EXT_OPERATIONAL,
  COMPANY_ACTIVITY_SETUP,
} from "data/standards/griStandards";
import NavigationButtons from "helper/navigation/NavigationButtons";
import ReusableFormComponent from "components/customizedStandardsComponent/EsgFormComponent";
import { ENVIROMENT_SOCIAL_DILIGENCE_FORM } from "data/forms/griFormSchema";
import {
  monitoringReportingFrequency,
  typesOfReportCompaniesOperational,
  dashboardDataProcessing,
  companyActivitySetup,
  screeningQuestions,
  complianceFrameworkActRisk,
  practicalRiskIdentificationEnvi,
  reportesDiligence,
} from "data/reports/relevantReports";
import ReportsReviewDialog from "components/customizedStandardsComponent/ReportsReviewDialog";
import UploadEvidenceReviewReports from "components/customizedStandardsComponent/UploadEvidenceReviewReports";

const EsDueDiligenceCompliance = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [prevStep, setPrevStep] = useState(0);
  const [reportData, setReportData] = useState({
    selectedStandards: [],
    companyInfo: {},
  });
  const [showReviewPopup, setShowReviewPopup] = useState(false);

  const steps = [
    "Project / Company & Activities Setup",
    "E&S Risk Screening",
    "Identify Compliance Requirements",
    "Key E&S Risks Identification",
    "ESG Compliance Form",
    "Upload Evidence",
    "Download Reports",
    "Upload Evidence Review Reports",
    "Download Post Review Gap Form",
    "Upload Post Review Gap Form",
    "Download Post Review Reports",
  ];

  // useEffect(() => {
  //     if (activeStep === 5 && prevStep === 4) {
  //         setShowReviewPopup(true);
  //     }
  // }, [activeStep, prevStep]);

  const handleNext = () => {
    if (activeStep < steps.length - 1) {
      setPrevStep(activeStep);
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const handleBack = () => {
    if (activeStep > 0) {
      setPrevStep(activeStep);
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };

  const handleSaveStandards = (selectedStandards) => {
    setReportData((prev) => ({
      ...prev,
      selectedStandards,
    }));
    console.log("Standards saved:", selectedStandards);
  };

  const handleClosePopup = () => {
    setShowReviewPopup(false);
  };

  const handleSkipToStep5 = () => {
    setPrevStep(activeStep);
    setActiveStep(6);
    setShowReviewPopup(false);
  };

  const COMPLIANCE_EVIDENCE_TYPES = [
    "EIA / IEE / Screening Report Approval",
    "Operational Environmental Permits (Air, Waste, Water)",
    "HR Policy / Sample Employment Contract",
    "OHS Plan / Safety Incident Log",
    "Stakeholder Consultation Records",
    "Grievance Redress Mechanism Procedure (basic)",
    "Hazardous Waste Disposal Certificates (if applicable)",
    "Water Use Licenses / Extraction Permits",
    "GHG/Emission Monitoring Data (if available)",
    "Biodiversity Impact Study (for sensitive locations)",
    "Insurance Certificates for OHS Coverage",
    "Climate Risk Screening (if conducted already)",
    "Others",
  ];

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <DownloadReport
            key="company-identification-operational-step"
            onPrevious={handleBack}
            showReportCountdownButton={true}
            onNext={handleNext}
            initialItems={companyActivitySetup}
            title="Project / Company & Activities Setup"
            ReportDownloadButtonShow={false}
          />
        );
      case 1:
        return (
          <DownloadReport
            key="activity-specification-operational-step"
            onPrevious={handleBack}
            onNext={handleNext}
            initialItems={screeningQuestions}
            title="E&S Risk Screening"
            ReportDownloadButtonShow={false}
          />
        );
      case 2:
        return (
          <DownloadReport
            key="requirement-selection-int-ext-operational-step"
            onPrevious={handleBack}
            onNext={handleNext}
            initialItems={complianceFrameworkActRisk}
            title="Identify Compliance Requirements"
            ReportDownloadButtonShow={false}
          />
        );
      case 3:
        return (
          <DownloadReport
            key="activity-specification-operational-step"
            onPrevious={handleBack}
            onNext={handleNext}
            initialItems={practicalRiskIdentificationEnvi}
            title="Key E&S Risks Identification"
            ReportDownloadButtonShow={false}
          />
        );
      case 4:
        return (
          <ReusableFormComponent
            key="esg-compliance-form-step"
            {...ENVIROMENT_SOCIAL_DILIGENCE_FORM}
            onNext={handleNext}
            onPrevious={handleBack}
            showPreviousButton={true}
          />
        );
      case 5:
        return (
          <UploadEvidenceComponent
            onPrevious={handleBack}
            onNext={handleNext}
            evidenceTypes={COMPLIANCE_EVIDENCE_TYPES}
          />
        );
      case 6:
        return (
          <DownloadReport
            key="climate-impact-reports-step"
            onPrevious={handleBack}
            onNext={handleNext}
            initialItems={reportesDiligence}
            title="Download Report relevant to your requirement"
            description="Download and review generated climate impact reports"
            stepId="step-8"
            showReportCountdownButton={true}
          />
        );
      case 7:
        return (
          <UploadEvidenceReviewReports
            onPrevious={handleBack}
            onNext={handleNext}
          />
        );
      case 8:
        return (
          <DownloadPostReviewGapForm
            onPrevious={handleBack}
            onNext={handleNext}
          />
        );
      case 9:
        return (
          <UploadPostReviewGapForm
            onPrevious={handleBack}
            onNext={handleNext}
          />
        );
      case 10:
        return (
          <DownloadPostReviewReports
            onPrevious={handleBack}
            standardName="E&S Due Diligence"
            showReportCountdownButton={true}
          />
        );
      default:
        return "Unknown step";
    }
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <PageHeader title="AI-Powered ESG Reporting across Global, National, Sectoral, and Industry-Specific Standards" />
          </Box>
          <Grid item xs={12}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <NavigationButtons
                imageKey="dashboardImg4_4"
                title={"E&S Due Diligence for ESG Compliance"}
                activeStep={activeStep}
                onBack={handleBack}
              />
            </Box>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          {getStepContent(activeStep)}
        </Grid>

        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: 4,
              mb: 2,
            }}
          >
            {steps.map((_, index) => (
              <Box
                key={index}
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  backgroundColor: index <= activeStep ? "#02462E" : "#e0e0e0",
                  mx: 1,
                }}
              />
            ))}
          </Box>
        </Grid>
      </Grid>

      <ReportsReviewDialog
        open={showReviewPopup}
        onClose={handleClosePopup}
        onSkip={handleSkipToStep5}
      />
    </>
  );
};

export default EsDueDiligenceCompliance;
